import { FloorForm, FloorListTable } from './component'

export default function Floor() {
    return (
        <div>
            <FloorForm />
            <FloorListTable />
        </div>
    )
}
